export default __webpack_public_path__ + "static/media/Matthew_Dochnal_IMG_013.8c8d5b86.jpg";